import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-clickCollectSelectDisabled",
  "use": "icon-clickCollectSelectDisabled-usage",
  "viewBox": "0 0 20 21",
  "content": "<symbol viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-clickCollectSelectDisabled\">\n<g id=\"icon-clickCollectSelectDisabled_frame\">\n<circle id=\"icon-clickCollectSelectDisabled_icon\" cx=\"10\" cy=\"10.5\" r=\"9\" fill=\"#F2F2F2\" stroke=\"#E5E5E5\" stroke-width=\"2\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol